export default "__VITE_ASSET__Cdc2su95__"